import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { BASIC_SIGNUP_OTP_HASH, HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  phone_number: yup.string().required(),
});

export const useBasicSignupSendOtpMutation = (options = {}) => {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });

    return http.post(HTTP_ENDPOINTS.basicSignupOtp.send(), {
      phone_number: req.phone_number,
      hash: BASIC_SIGNUP_OTP_HASH,
    });
  }, options);
};
